import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { LoginScreen } from '../components/auth/LoginScreen'
import { lazy } from 'react'

const Report = lazy(()=> import(/* webpackChunkName: "Report"*/'../components/ExecutiveReport/Report'))

export const AuthRuouter = () => {
    return (
        <div className="auth__main">
            <div className="auth__box-container">
                <Switch>
                    <Route 
                        path="/auth/login" 
                        component={LoginScreen}
                    />
                    <Route 
                        path="/auth/report" 
                        component={Report}
                    />
                    <Redirect to="/auth/login"/>
                </Switch>
            </div>
        </div>
    )
}
